<template>
  <apexchart
    v-if="loaded"
    type="bar"
    width="100%"
    height="350"
    :options="chartOptions"
    :series="series"
  ></apexchart>

  <v-skeleton-loader v-else class="mx-auto" type="image"></v-skeleton-loader>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  data() {
    return {
      error: null,
      chartOptions: null,
      series: [],
      loaded: false,
    };
  },
  methods: {
    getChartData() {
      let that = this;
      axios
        .get("/api/v1/ticket/new-per-agent")
        .then((response) => {
          // Stacked chart data

          that.series = response.data.data;
          that.chartOptions = {
            tooltip: {
              theme: "dark",
            },
            // colors: [
            //   "#B282B5",
            //   "#8E57A2",
            //   "#6E3289",
            //   "#4F1B70",
            //   "#34035A",
            //   "#2E0E53",
            //   "#271A4C",
            //   "#202545",
            //   "#191E3D",
            //   "#121936",
            //   "#AC77AD",
            //   "#986C9B",
            //   "#805A86",
            //   "#674571",
            //   "#4F356B",
            //   "#462D62",
            //   "#3C2458",
            //   "#331F4F",
            //   "#291845",
            //   "#20123B",
            // ],
            chart: {
              id: "tickets-per-agent",
              stacked: true,
            },
            dataLabels: {
              enabled: false,
            },
            zoom: {
              type: "x",
              enabled: true,
              autoScaleYaxis: true,
              zoomedArea: {
                fill: {
                  type: "gradient",
                },
              },
            },
            xaxis: {
              categories: response.data.headers,
              type: "datetime",
              labels: {
                formatter: function (val) {
                  return moment(val).format("dddd - DD MMM YYYY");
                },
              },
            },
          };
        })
        .then(() => {
          that.loaded = true;
        });
    },
    getSeriesData() {
      let that = this;
      axios.get("/api/v1/ticket/new-per-agent").then((response) => {
        that.series = response.data.data;
      });
    },
  },
  created() {
    this.getChartData();
  },
};
</script>

<style lang="scss" scoped></style>
